import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PlaylistPage from './pages/PlaylistPage';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* index is optional and is 1-based (e.g. /playlist/:id/1) */}
        <Route path="/playlist/:id/:index?" element={<PlaylistPage />} />
      </Routes>
    </Router>
  );
};

export default App;